module.exports = __webpack_public_path__ + "img/audiosource.a1048c86.jpg";